import { createRouteNode } from '@owlsdepartment/vue-tree-routes';
import { RouteMeta } from 'vue-router';

import { Subject } from '@/common/abilities';
import LayoutProduction from '@/layouts/LayoutProduction.vue';

const meta: RouteMeta = {
	abilitySubject: Subject.PRODUCTION_PANEL,
	layout: {
		component: LayoutProduction,
	},
};

const productionRoutes = createRouteNode({
	shared: {
		basePath: '/production',
		meta,
	},

	routes: [
		{
			name: 'Production',
			path: '/',
			component: () => import('@/views/production/ViewProductionDashboard.vue'),
			meta: {
				...meta,
				headline: 'Production Management',
			},
		},
		{
			path: 'queue',
			name: 'ProductionQueue',
			component: () => import('@/views/production/ViewProductionQueue.vue'),
			meta: {
				...meta,
				headline: 'Production Queue',
			},
		},
		{
			path: 'queue/:id',
			name: 'ProductionQueueDetails',
			component: () => import('@/views/production/ViewProductionQueueDetails.vue'),
			meta: {
				...meta,
				headline: 'Production Details',
			},
		},
		{
			path: 'timeline',
			name: 'ProductionTimeline',
			component: () => import('@/views/production/ViewProductionTimeline.vue'),
			meta: {
				...meta,
				headline: 'Production Timeline',
			},
		},
		{
			path: 'products',
			name: 'Products',
			component: () => import('@/views/production/ViewProducts.vue'),
			meta: {
				...meta,
				headline: 'Product Cards',
			},
		},
		{
			path: 'products/:id',
			name: 'ProductDetails',
			component: () => import('@/views/production/ViewProductDetails.vue'),
			meta: {
				...meta,
				headline: 'Product Details',
			},
		},
		{
			path: 'products/:id/variations',
			name: 'ProductVariationsManager',
			component: () => import('@/views/production/ViewProductVariationsManager.vue'),
			meta: {
				...meta,
				headline: 'Product Variations Manager',
			},
		},
		{
			path: 'products/:id/norms',
			name: 'ProductNorms',
			component: () => import('@/views/production/ViewProductNorms.vue'),
			meta: {
				...meta,
				headline: 'Product Norms',
			},
		},
		{
			path: 'components',
			name: 'Components',
			component: () => import('@/views/production/ViewComponents.vue'),
			meta: {
				...meta,
				headline: 'Components Catalog',
			},
		},
		{
			path: 'suppliers',
			name: 'Suppliers',
			component: () => import('@/views/production/ViewSuppliers.vue'),
			meta: {
				...meta,
				headline: 'Suppliers',
			},
		},
		{
			path: 'reports',
			name: 'ProductionReports',
			component: () => import('@/views/production/ViewProductionReports.vue'),
			meta: {
				...meta,
				headline: 'Production Reports',
			},
		},
		{
			path: 'reports/efficiency',
			name: 'ProductionReportEfficiency',
			component: () => import('@/views/production/reports/ViewProductionReportEfficiency.vue'),
			meta: {
				...meta,
				headline: 'Efficiency Report',
			},
		},
		{
			path: 'reports/time-analysis',
			name: 'ProductionReportTimeAnalysis',
			component: () => import('@/views/production/reports/ViewProductionReportTimeAnalysis.vue'),
			meta: {
				...meta,
				headline: 'Time Analysis',
			},
		},
		{
			path: 'reports/cost-analysis',
			name: 'ProductionReportCostAnalysis',
			component: () => import('@/views/production/reports/ViewProductionReportCostAnalysis.vue'),
			meta: {
				...meta,
				headline: 'Cost Analysis',
			},
		},
		{
			path: 'reports/status-overview',
			name: 'ProductionReportStatusOverview',
			component: () => import('@/views/production/reports/ViewProductionReportStatusOverview.vue'),
			meta: {
				...meta,
				headline: 'Status Overview',
			},
		},
	],
});

export default productionRoutes;
